module.exports = function (fox, _publicPath_) {
 /* fox-dynamic-injection */ 
// Layout_Support

(function (fox, $) {
	
	fox.registerWidget('Layout_Support', {
		configure: function () {
		 	this.registerOptions('', {
				handleDom: {
					showHelpRequestPopup: {
						event: 'click',
						target: '.help-request-block',
						callback: '.SitePage_Support #helpRequest:show'
					},
					searchArticle: {
						event: 'click',
						target: '#search-article .icon',
						callback: '.SitePage_Support:searchPost'
					},
					searchArticleOnKeyPress: {
						event: 'keyup',
						target: '#search-article input',
						callback: '.SitePage_Support:searchPost'
					}
				}	
		 	});

		 	this.callParent('configure', arguments);
		 }

	}, 'Layout_Base');

})(fox, jQuery);
 /* fox-dynamic-injection */ 
};


//////////////////
// WEBPACK FOOTER
// ../common/widget/layout/support.js
// module id = 468
// module chunks = 2